// services/reservas.ts
import { AuthFetch } from "../hooks/useApi";
import {
  Reserva,
  ReservaCreatePayload,
  ReservaUpdatePayload,
  DoctorReservasResponse,
  DoctorReservaLinkPayload,
} from "../types/reserva.types";

export const reservaService = {

  create: (
    apiFetch: AuthFetch,
    payload: ReservaCreatePayload,
  ): Promise<Reserva> =>
    apiFetch<Reserva>(`/reservas/`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),

  search: (
    apiFetch: AuthFetch,
    query: string,
  ): Promise<Reserva[]> =>
    apiFetch<Reserva[]>(`/reservas/search?q=${encodeURIComponent(query)}`, {
      method: "GET",
    }),

  get: (
    apiFetch: AuthFetch,
    id: number,
  ): Promise<Reserva> =>
    apiFetch<Reserva>(`/reservas/${id}`, {
      method: "GET",
    }),

  update: (
    apiFetch: AuthFetch,
    id: number,
    payload: ReservaUpdatePayload,
  ): Promise<Reserva> =>
    apiFetch<Reserva>(`/reservas/${id}`, {
      method: "PUT",
      body:   JSON.stringify(payload),
    }),

  listForDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
  ): Promise<DoctorReservasResponse> =>
    apiFetch<DoctorReservasResponse>(`/doctors/${doctorEmail}/reservas`, {
      method: "GET",
    }),

  linkToDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    payload: DoctorReservaLinkPayload,
  ): Promise<void> =>
    apiFetch<void>(`/doctors/${doctorEmail}/reservas`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),

  unlinkFromDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    reservaId: number,
  ): Promise<void> =>
    apiFetch<void>(`/doctors/${doctorEmail}/reservas/${reservaId}`, {
      method: "DELETE",
    }),
};
